module.exports = __webpack_public_path__ + "img/ic_dots.ee521f4c.svg";